export default __webpack_public_path__ + "static/media/17.5e0459c6.jpg";